module.exports = __webpack_public_path__ + "img/landingpage-bg2.4a7322b4.png";